<script>
	import { fade } from 'svelte/transition';

	export let delay = 600;
</script>

<div class="loading-spinner" in:fade={{ duration: 100, delay }} out:fade={{ duration: 100 }}>
	<div />
	<div />
</div>

<style>.loading-spinner{--loading-spinner-border-width:3px;display:inline-block;position:relative;width:2rem;width:var(--size, 2rem);height:2rem;height:var(--size, 2rem)}.loading-spinner div{box-sizing:border-box;display:block;position:absolute;width:var(--size);height:var(--size);border:var(--loading-spinner-border-width) solid hsla(var(--hsl-primary));border-radius:50%;animation:rotate 1s cubic-bezier(.5,0,.5,1) infinite;border-color:hsla(var(--hsl-primary)) transparent transparent}.loading-spinner:nth-child(1){animation-delay:-.375s}</style>
